import React from "react";
import { Redirect, Switch } from "react-router-dom";
import { CustomerRoute, PrivateRoute } from "helper/route";
import AllInOneLayout from "components/allInOneDashboard/AllInOneLayout";
import UnifiedDashboard from "pages/AllInOneDashboard/UnifiedDashboard";
import HoldingsHub from "pages/AllInOneDashboard/HoldingsHub";
import MarketPulseHub from "pages/AllInOneDashboard/MarketPulseHub";
import Profile from "pages/Customer/Profile";
import Blogs from "pages/KnowledgeCentre/Blogs";
import SubscriptionDetails from "pages/Customer/SubscriptionDetails";
import EditProfile from "pages/Customer/EditProfile";

/**
 * Single shared AllInOneLayout for all primary All-In-One pages so the
 * top/bottom nav never remounts when switching tabs.
 */
const AllInOneRoutes = ({
  match,
  isAuthenticated,
  isOnboardingCompleted,
}) => (
  <AllInOneLayout>
    <Switch>
      <PrivateRoute
        exact
        auth={{ isAuthenticated }}
        path={`${match.path}/dashboard`}
        component={UnifiedDashboard}
      />
      <PrivateRoute
        exact
        auth={{ isAuthenticated }}
        path={`${match.path}/holdings`}
        component={HoldingsHub}
      />
      <PrivateRoute
        exact
        auth={{ isAuthenticated }}
        path={`${match.path}/market-pulse`}
        component={MarketPulseHub}
      />
      <PrivateRoute
        exact
        auth={{ isAuthenticated }}
        path={`${match.path}/blogs`}
        component={Blogs}
      />
      <CustomerRoute
        exact
        isAuthenticated={isAuthenticated}
        isOnboardingCompleted={isOnboardingCompleted}
        path={`${match.path}/profile`}
        component={Profile}
      />
      <CustomerRoute
        exact
        isAuthenticated={isAuthenticated}
        isOnboardingCompleted={isOnboardingCompleted}
        path={`${match.path}/profile/subscription`}
        component={SubscriptionDetails}
      />
      <CustomerRoute
        exact
        isAuthenticated={isAuthenticated}
        isOnboardingCompleted={isOnboardingCompleted}
        path={`${match.path}/profile/edit-profile`}
        component={EditProfile}
      />
      <Redirect to={`${match.path}/dashboard`} />
    </Switch>
  </AllInOneLayout>
);

export default AllInOneRoutes;
